<div #graphContainer >
  <div class="row" style="margin-left: 4%; white-space: nowrap">

    @if (panel_name !== 'Spectrum') {
      <span class="col-md-2">trace: {{traceNumber | number: "1.0-0"}}</span>
    }
    @if (panel_name !== 'Spectrum') {
      <span class="col-md-2">time: {{timeNumber | number: "1.0-3"}}</span>
    }
    @if (_isInterleave) {
      <span class="col-md-2" style="white-space: nowrap;">from: {{interleaveType}}</span>
    }
    @if (panel_name === 'Spectrum') {
      <div class="col-md-5" style="white-space: nowrap; font-family: monospace;">
        <div style="display: flex;">
          <span style="width: 80px;">frequency:</span>
          <span style="width: 100px; text-align: right;">{{predictedX | number: "1.0-3"}} Hz</span>
        </div>
        <div style="display: flex;">
          <span style="width: 80px;">predicted:</span>
          <span style="width: 100px; text-align: right;">{{predictedY | number: "1.0-3"}} dB</span>
          <span style="width: 20px; text-align: center;">|</span>
          <span style="width: 50px;">field:</span>
          <span style="width: 100px; text-align: right;">{{fieldY | number: "1.0-3"}} dB</span>
        </div>
      </div>
    }
    <div class="zoom-factor">Zoom Factor: {{zoomFactor}}</div>
  </div>
  <svg id="svg" #graph></svg>
</div>

